<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "catalog_pagination_settings_label" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <web-pages-settings [pagesButtonsFormGroup]="pagesButtonsFormGroup"></web-pages-settings>
        <web-current-page-settings [currentPageFormGroup]="currentPageFormGroup"></web-current-page-settings>
        <web-next-page-settings [nextPageFormGroup]="nextPageFormGroup"></web-next-page-settings>
    </div>
</div>

<web-settings-footer
    [isSaveDisabled]="saveDisablePredicate"
    (saveEvent)="onSave()"
    (cancelEvent)="onReset()"
></web-settings-footer>
